import { createReducer } from '@reduxjs/toolkit';
import { getTransactionDetailsRequest, getTransactionDetailsSuccess, getTransactionDetailsFailure, getViewLocationDetailsRequest, getViewLocationDetailsSuccess, getViewLocationDetailsFailure } from '../actions/transactionActions';
  
const initialState = {
	transactionDetailsLoading: false,
	transactionDetails: null,
	transactionDetailsError: null,
	viewLocationDetailsLoading: false,
	viewLocationDetails: null,
	viewLocationDetailsError: null
};

const transactionReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(getTransactionDetailsRequest, (state, action) => {
			state.transactionDetails = {};
			state.transactionDetailsLoading= true;
		}).addCase(getTransactionDetailsSuccess, (state, action) => {
			state.transactionDetailsLoading= false;
			state.transactionDetails= action.payload;
		}).addCase(getTransactionDetailsFailure, (state, action) => {
			state.transactionDetailsLoading= false;
			state.transactionDetails = { msg: 'ERROR', details: action.payload };
		}).addCase(getViewLocationDetailsRequest, (state, action) => {
			state.viewLocationDetails = {};
			state.viewLocationDetailsLoading= true;
			state.viewLocationDetailsError= false;
			state.viewLocationDetails= '';
		}).addCase(getViewLocationDetailsSuccess, (state, action) => {
			state.viewLocationDetailsLoading= false;
			state.viewLocationDetails= action.payload;
			state.viewLocationDetailsError= false;
		}).addCase(getViewLocationDetailsFailure, (state, action) => {
			state.viewLocationDetailsLoading= false;
			state.viewLocationDetails = { msg: 'ERROR', details: action.payload };
			state.viewLocationDetailsError=true;
		})
});
  
export default transactionReducer;
